(function () {
  if (window.__storyCirclesInit) return;
  window.__storyCirclesInit = true;

  /* ------------------------------------------------------------------ *
   * Hoist every story-circles modal to <body> so CSS fixed positioning
   * works correctly regardless of ancestor stacking contexts (the sticky
   * product-info column would otherwise trap the modal).
   * ------------------------------------------------------------------ */
  function hoistModals() {
    document.querySelectorAll('.story-circles-modal').forEach(function (modal) {
      if (modal.parentNode !== document.body) {
        document.body.appendChild(modal);
      }
    });
    document.querySelectorAll('.story-circles__media').forEach(function (v) {
      if (v.tagName === 'VIDEO') {
        v.setAttribute('playsinline', '');
        v.setAttribute('disablepictureinpicture', '');
        v.disablePictureInPicture = true;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hoistModals);
  } else {
    hoistModals();
  }

  /* ------------------------------------------------------------------ *
   * Global click delegation
   * ------------------------------------------------------------------ */
  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-story-open]');
    if (opener) { openStory(opener); return; }

    var closer = event.target.closest('[data-story-close]');
    if (closer) { closeStory(closer.closest('.story-circles-modal')); }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      document.querySelectorAll('.story-circles-modal:not([hidden])').forEach(closeStory);
    }
  });

  /* ------------------------------------------------------------------ *
   * openStory(opener)
   *   opener  – the <button data-story-open> that was clicked
   * ------------------------------------------------------------------ */
  function openStory(opener) {
    hoistModals();

    // Find the associated modal (same story-circles row).
    var circlesRow = opener.closest('.story-circles');
    var modal = circlesRow
      ? (circlesRow.dataset.modalId && document.getElementById(circlesRow.dataset.modalId))
      : null;
    if (!modal) modal = document.querySelector('.story-circles-modal');
    if (!modal) return;

    // --- VIDEO -----------------------------------------------------------
    var template  = opener.querySelector('template[data-story-full]');
    var mediaSlot = modal.querySelector('[data-story-media]');
    if (!template || !mediaSlot) return;

    // Pause the looping thumbnail.
    var thumbVideo = opener.querySelector('video');
    if (thumbVideo) thumbVideo.pause();

    // Clone the full-size video into the media slot.
    mediaSlot.innerHTML = '';
    mediaSlot.appendChild(template.content.cloneNode(true));

    var fullVideo = mediaSlot.querySelector('video');
    if (fullVideo) {
      fullVideo.muted = false;
      fullVideo.currentTime = 0;
      fullVideo.setAttribute('playsinline', '');
      fullVideo.setAttribute('disablepictureinpicture', '');
      fullVideo.disablePictureInPicture = true;
      fullVideo.play().catch(function () {});
    }

    // --- LINKED PRODUCT --------------------------------------------------
    var productSlot = modal.querySelector('[data-story-product-slot]');
    if (productSlot) {
      productSlot.innerHTML = '';
      var rawJson = opener.getAttribute('data-story-product');
      if (rawJson) {
        try {
          var p = JSON.parse(rawJson);
          productSlot.innerHTML = buildProductCard(p);
        } catch (e) {
          // malformed JSON — silently ignore
        }
      }
    }

    // --- SHOW MODAL -------------------------------------------------------
    // Force critical positioning inline so it can never be defeated by a
    // stale stylesheet or cascade conflict.
    modal.style.position        = 'fixed';
    modal.style.inset           = '0';
    modal.style.zIndex          = '999999';
    modal.style.display         = 'flex';
    modal.style.alignItems      = 'center';
    modal.style.justifyContent  = 'center';
    modal.hidden                = false;
    document.body.style.overflow = 'hidden';
  }

  /* ------------------------------------------------------------------ *
   * closeStory(modal)
   * ------------------------------------------------------------------ */
  function closeStory(modal) {
    if (!modal) return;

    var mediaSlot = modal.querySelector('[data-story-media]');
    if (mediaSlot) {
      var video = mediaSlot.querySelector('video');
      if (video) video.pause();
      mediaSlot.innerHTML = '';
    }

    var productSlot = modal.querySelector('[data-story-product-slot]');
    if (productSlot) productSlot.innerHTML = '';

    modal.hidden = true;
    modal.style.display = 'none';
    document.body.style.overflow = '';

    // Resume autoplay thumbnails.
    document.querySelectorAll('.story-circles__item--playable video').forEach(function (v) {
      v.play().catch(function () {});
    });
  }

  /* ------------------------------------------------------------------ *
   * buildProductCard(p)
   *   p – { url, title, price, image, alt }
   *   Returns an HTML string for the compact product card shown in the
   *   story popup below the video.
   * ------------------------------------------------------------------ */
  function buildProductCard(p) {
    var imgHtml = p.image
      ? '<img src="' + esc(p.image) + '" alt="' + esc(p.alt || p.title) + '" width="72" height="72" loading="lazy">'
      : '';

    return [
      '<a href="' + esc(p.url) + '" class="sc-product-card">',
        '<span class="sc-product-card__img">',
          imgHtml,
        '</span>',
        '<span class="sc-product-card__info">',
          '<span class="sc-product-card__title">' + esc(p.title) + '</span>',
          '<span class="sc-product-card__price">' + esc(p.price) + '</span>',
        '</span>',
        '<span class="sc-product-card__cta">Shop now &#8594;</span>',
      '</a>'
    ].join('');
  }

  function esc(str) {
    return String(str)
      .replace(/&/g,  '&amp;')
      .replace(/</g,  '&lt;')
      .replace(/>/g,  '&gt;')
      .replace(/"/g,  '&quot;');
  }
})();
